import {Component, EventEmitter, Injector, OnInit, Output, ViewChild} from '@angular/core';
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {PageHeaderTab} from "@core-components/page-header/page-header-tabs.interface";
import {ConsoleContextService} from "@security/console-context.service";
import {Subject} from "rxjs";
import {AgreementType, LeaseViewSection, OccupancyType} from "../leasing.model";
import {LeasePosSettingsComponent} from "./lease-pos-settings/lease-pos-settings.component";

@Component({
  selector: 'app-lease-view',
  templateUrl: './lease-view.component.html',
})
export class LeaseViewComponent extends BasePageComponent implements OnInit {
  @ViewChild('posSettingsComponent') posSettingsComponent!: LeasePosSettingsComponent;

  @Output() updateLeaseStatus = new EventEmitter<void>();

  leaseId!: string;
  occupancyType!: OccupancyType;
  agreementType!: AgreementType;

  hideSections: LeaseViewSection[] = [];
  embedded = false;

  tabs: PageHeaderTab[] = [
    {
      name: 'Details',
      isActive: true,
      code: "lease_details",
      disabled: false
    },
    {
      name: 'Showcase',
      isActive: false,
      code: "lease_showcase",
      disabled: false
    },
    {
      name: 'Turnover',
      isActive: false,
      code: "lease_turnover",
      disabled: true
    }
  ];

  isTabbed = true;
  activeTab: string = "lease_details"
  reloadSubject: Subject<void> = new Subject<void>();
  reloadPosSubject: Subject<void> = new Subject<void>();

  constructor(injector: Injector, private contextService: ConsoleContextService) {
    super(injector);
    this.leaseId = this.data.id;
    this.occupancyType = this.data.occupancyType;
    this.agreementType = this.data.agreementType;
    if (this.data.hiddenSections) {
      this.hideSections = this.data.hiddenSections;
      if (this.hideSections.includes(LeaseViewSection.TABS)) this.isTabbed = false;
    }
    this.embedded = this.data.embedded;

    this.tabs[2].disabled = !this.contextService.checkUserFeatures(['leasing_current_view_sales_upload', 'leasing_current_edit_sales_upload', 'leasing_current_view_turnover_upload', 'leasing_current_edit_turnover_upload'],  this.offering!.offeringUuid);
  }

  ngOnInit() {
    if (!this.leaseId && this.data.id) {
      this.leaseId = this.data.id;
      this.occupancyType = this.data.occupancyType;
      this.agreementType = this.data.agreementType;
      if (this.data.hiddenSections) {
        this.hideSections = this.data.hiddenSections;
        if (this.hideSections.includes(LeaseViewSection.TABS)) this.isTabbed = false;
      }
      this.embedded = this.data.embedded;
    }
  }

  changeTabs($event: PageHeaderTab): void {
    this.activeTab = $event.code;
  }

  getInitialTab(): PageHeaderTab {
    return this.tabs.at(0)!;
  }

  reloadLeaseDetails() {
    this.reloadSubject.next();
  }

  reloadPosSettings() {
    this.reloadPosSubject.next();
  }

  get isHeadLease() {
    return this.occupancyType == OccupancyType.SHARED && this.agreementType == AgreementType.LEASE;
  }

  get isSubLease() {
    return this.occupancyType == OccupancyType.SHARED && this.agreementType == AgreementType.SUB_LEASE;
  }

  showSection(section: LeaseViewSection) {
    return !this.hideSections.includes(section);
  }

  protected readonly OccupancyType = OccupancyType;
  protected readonly AgreementType = AgreementType;
  protected readonly LeaseViewSection = LeaseViewSection;
}
